/**
 * created by yxy
 * 采访任务 任务详情页
 */
import React, {Component} from 'react';
import BaseComponent from "../../../../base/BaseComponent";
import {Input, Form, Modal, Checkbox, Icon} from 'antd';
import {uuid} from "../../../../utils";
import {Scrollbars} from "react-custom-scrollbars";

const config = [
    [{
        componentType: "TaskDetail", // UI类型
        value: "this.state.propsData.title", // 值所在位置
        label: "任务名称", // 标签名
        labelCode: "title", // 标签key
        placeholder: "请输入任务名称", // 空输入框提示
        maxLength: 1, // 最大长度
        message: "请输入任务名称", // 校验提示
        required: true, // 是否必填
        disabled: false, // 是否禁用
        id: "information_titlePic", // 标签id
        size: "default", // 标签大小
        show:true,
        type:'createTask'
    },
        // {
        //     componentType: "TextShow", // UI类型
        //     value: "this.state.simulateData.attribution", // 值所在位置
        //     label: "所属项目", // 标签名
        //     labelCode: "title", // 标签key
        //     placeholder: "请输入任务名称", // 空输入框提示
        //     maxLength: 1, // 最大长度
        //     message: "请输入任务名称", // 校验提示
        //     required: true, // 是否必填
        //     disabled: false, // 是否禁用
        //     id: "information_titlePic", // 标签id
        //     size: "default", // 标签大小
        // }
    ],
    [{
        componentType: "ViewTaskTime", // UI类型
        value: "this.state.propsData.startTime,this.state.propsData.endTime", // 值所在位置
        label: "任务时间", // 标签名
        labelCode: "title", // 标签key
        placeholder: "请输入任务名称", // 空输入框提示
        maxLength: 1, // 最大长度
        message: "请输入任务名称", // 校验提示
        required: true, // 是否必填
        disabled: false, // 是否禁用
        id: "information_titlePic", // 标签id
        size: "default", // 标签大小
        show:true,
        type:'createTask'
    },
        {
            componentType: "TextShow", // UI类型
            value: "this.state.propsData.place", // 值所在位置
            label: "任务地点", // 标签名
            labelCode: "title", // 标签key
            placeholder: "请输入任务名称", // 空输入框提示
            maxLength: 1, // 最大长度
            message: "请输入任务名称", // 校验提示
            required: true, // 是否必填
            disabled: false, // 是否禁用
            id: "information_titlePic", // 标签id
            size: "default", // 标签大小
            show:true,
            type:'createTask'
        }],
    [{
        componentType: "ViewTime", // UI类型
        value: "this.state.propsData.replyTime", // 值所在位置
        label: "回稿时间", // 标签名
        labelCode: "title", // 标签key
        placeholder: "请输入任务名称", // 空输入框提示
        maxLength: 1, // 最大长度
        message: "请输入任务名称", // 校验提示
        required: true, // 是否必填
        disabled: false, // 是否禁用
        id: "information_titlePic", // 标签id
        size: "default", // 标签大小
        show:true,
        type:'createTask'
    },
        {
            componentType: "TextShow", // UI类型
            value: "this.state.propsData.sponsor", // 值所在位置
            label: "主办单位", // 标签名
            labelCode: "title", // 标签key
            placeholder: "请输入任务名称", // 空输入框提示
            maxLength: 1, // 最大长度
            message: "请输入任务名称", // 校验提示
            required: true, // 是否必填
            disabled: false, // 是否禁用
            id: "information_titlePic", // 标签id
            size: "default", // 标签大小
            show:true,
            type:'createTask'
        }],
    [{
        componentType: "TextShow", // UI类型
        value: "this.state.propsData.contacts", // 值所在位置
        label: "联系人", // 标签名
        labelCode: "title", // 标签key
        placeholder: "请输入任务名称", // 空输入框提示
        maxLength: 1, // 最大长度
        message: "请输入任务名称", // 校验提示
        required: true, // 是否必填
        disabled: false, // 是否禁用
        id: "information_titlePic", // 标签id
        size: "default", // 标签大小
        show:true,
        type:'createTask'
    },
        {
            componentType: "TextShow", // UI类型
            value: "this.state.propsData.contactsWay", // 值所在位置
            label: "联系方式", // 标签名
            labelCode: "title", // 标签key
            placeholder: "请输入任务名称", // 空输入框提示
            maxLength: 1, // 最大长度
            message: "请输入任务名称", // 校验提示
            required: true, // 是否必填
            disabled: false, // 是否禁用
            id: "information_titlePic", // 标签id
            size: "default", // 标签大小
            show:true,
            type:'createTask'
        }],
    [{
        componentType: "ViewTime", // UI类型
        value: "this.state.propsData.createTime", // 值所在位置
        label: "创建时间", // 标签名
        labelCode: "title", // 标签key
        placeholder: "请输入任务名称", // 空输入框提示
        maxLength: 1, // 最大长度
        message: "请输入任务名称", // 校验提示
        required: true, // 是否必填
        disabled: false, // 是否禁用
        id: "information_titlePic", // 标签id
        size: "default", // 标签大小
        show:true,
        type:'createTask'
    },
        {
            componentType: "TextShow", // UI类型
            value: "this.state.propsData.taskReporterObjs", // 值所在位置
            label: "我的角色", // 标签名
            labelCode: "title", // 标签key
            placeholder: "请输入任务名称", // 空输入框提示
            maxLength: 1, // 最大长度
            message: "请输入任务名称", // 校验提示
            required: true, // 是否必填
            disabled: false, // 是否禁用
            id: "information_titlePic", // 标签id
            size: "default", // 标签大小
            show: 'that.permissionCheck("interview_accept")',
            type:'receiver'
        }],
    [{
        componentType: "TaskDetail", // UI类型
        value: "this.state.propsData.content", // 值所在位置
        label: "任务内容", // 标签名
        labelCode: "title", // 标签key
        placeholder: "请输入任务名称", // 空输入框提示
        maxLength: 1, // 最大长度
        message: "请输入任务名称", // 校验提示
        required: true, // 是否必填
        disabled: false, // 是否禁用
        id: "information_titlePic", // 标签id
        size: "default", // 标签大小
        show:true,
        type:'createTask'
    }],
    [{
        componentType: "ReleaseMedia", // UI类型
        value: "this.state.propsData.medias", // 值所在位置
        label: "发布媒体", // 标签名
        labelCode: "title", // 标签key
        placeholder: "请输入任务名称", // 空输入框提示
        maxLength: 1, // 最大长度
        message: "请输入任务名称", // 校验提示
        required: true, // 是否必填
        disabled: false, // 是否禁用
        id: "information_titlePic", // 标签id
        size: "default", // 标签大小
        show:true,

    }],
    [{
        componentType: "TaskReporter", // UI类型
        value: "this.state.propsData.taskReporterObjs", // 值所在位置
        label: "任务记者", // 标签名
        labelCode: "title", // 标签key
        placeholder: "请输入任务名称", // 空输入框提示
        maxLength: 1, // 最大长度
        message: "请输入任务名称", // 校验提示
        required: true, // 是否必填
        disabled: false, // 是否禁用
        id: "information_titlePic", // 标签id
        size: "default", // 标签大小
        show:true
    }],
    [{
        componentType: "Attachment", // UI类型
        value: "this.state.propsData.attachments", // 值所在位置
        label: "附件", // 标签名
        labelCode: "attachments", // 标签key
        placeholder: "请输入任务名称", // 空输入框提示
        maxLength: 1, // 最大长度
        message: "请上传附件", // 校验提示
        required: false, // 是否必填
        disabled: false, // 是否禁用
        id: "information_attachments", // 标签id
        size: "default", // 标签大小
        show:true
    }]

];

class TaskMessage extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};
    id = uuid();

    constructor(props) {
        super(props);
        this.state = {
            id: '',
            visible: false,//控制弹框显隐
            fid: '',
            information: {
                title: '',
                "taskTopicId": "627eacafa371430001c1ae10",
                place: '',
                sponsor: "",
                contacts: "",
                contactsWay: "",
                content: "",
                medias: [],//选择的媒体
                taskReporterIds: [],
                attachments: []
            },
            simulateData: {
                title: "这是任务名称",
                attribution: "这是专题项目",
                startTime: 1666158183062,
                endTime: 1666666666666,
                place: "体育馆",
                replyTime: 1666503760555,
                sponsor: "博达",
                contacts: "张三",
                contactsWay: "13011111111",
                createTime: 1666158183062,
                myRole: "文字记者",
                content: '任务内容任务内容任务内容任务内容任务内容任务内容任务内容任务内容任务内容任务内容任务内容任务内容任务' +
                    '内容任务内容任务内容任务内容任务内容任务内容任务内容任务内容任务内容任务内容任务内容任务内容任务内容',
                medias: ['媒体001', '媒体002'],
                taskReporterList: [{
                    reporterName: '张三',
                    account: 'zhangsan',
                    category: ['文字记者', '摄影记者'],
                    getState: '已领取'
                }, {
                    reporterName: '张三',
                    account: 'zhangsan',
                    category: ['文字记者'],
                    getState: '未领取'
                }, {
                    reporterName: '张三',
                    account: 'zhangsan',
                    category: ['文字记者'],
                    getState: '未领取'
                }, {
                    reporterName: '张三',
                    account: 'zhangsan',
                    category: ['文字记者'],
                    getState: '未领取'
                }],
                attachments: [{
                    uid: '11111',
                    name: '12345.png',
                    path: '111111111',
                    url: 'http://www.baidu.com/zzz.png',
                    status: 'done',
                }]
            },//模拟的数据
            propsData: [],//真实数据
            taskId: props.id,
        }

    }

    componentDidMount() {
        let that = this;
        this.createPostMessage((e) => {
            let message = e['data'] ? JSON.parse(e['data'])['message'] : null;
            if (message == "请求刷新父页面") {
                that.getPropsData();
                that.props.callBack&&that.props.callBack()
            }
        }, "TaskMessage")
        this.getPropsData()
    }
    componentWillUnmount() {
        // 销毁postMessage监听
        this.destroyPostMessage("TaskMessage")
    }


    getPropsData = () => {
        let url = '/cm-sites-business/bd/busTask/getById/';
        this.request({
            url: "" + url + this.state.taskId,
            method: "post",
            body: {
                "showRef": [
                    "taskReporterIds",
                    "clueId",
                    "topicSelectionId"
                ]
            },
            contentType: 'json',
            callBack: (data) => {
                if (data) {
                    this.setState({
                        propsData:data
                    },()=>{

                    })
                }
            }
        });
    };

    componentWillReceiveProps(nextProps, nextContext) {
        if (this.state.taskId !== nextProps.id) {
            this.setState({taskId: nextProps.id}, () => {
                this.getPropsData()
            })
        }
    }

    render() {
        let id = `a-${this.id}-modal`;
        return (
            <Scrollbars
                autoHeight={true}
                autoHeightMax={444}
                autoHide
            >
                <div className={'checkTask'} style={{padding: '0px 20px'}}>
                    <div id={id}>{
                        config && config.length && config.map((item, index) => {
                            return (
                                <div key={index} style={{
                                    display: item && item.length > 1 ? "flex" : '',
                                    justifyContent: item && item.length > 1 ? "space-between" : '',
                                    alignItems:item && item.length > 1 ? "flex-start" : '',
                                    marginBottom: 0
                                }}>{
                                    item.map((componentItem, _index) => {
                                        return this.renderItem(componentItem, _index, index)
                                    })}
                                </div>
                            )
                        })

                        // <Text></Text>
                    }</div>
                    <style>{`
                            #${id} .ant-form-item{
                                margin-bottom:0px !important
                            }
                            #${id} .ant-form-item-label{
                                width: ${config.labelWidth || 80}px;
                                vertical-align: top;
                                height:40px;
                            }
                            #${id} .ant-form-item-label label{
                                color:rgba(0, 0, 0, 0.45)
                            }
                            #${id} .ant-form-item .ant-form-item-control-wrapper .ant-form-item-control{
                                line-height: '' !important;
                            }

                        `}</style>
                </div>

            </Scrollbars>
        );
    }

    renderItem = (componentItem, _index, index) => {
        let that = this;
        let show = true;
        let ItemComponent = null;
        try {
            if(componentItem.show && typeof componentItem.show === 'string') {
                let newShow = componentItem.show;
                // console.log("newShow",newShow);
                // console.log("newShow",eval(newShow));
                show = eval(newShow) ? true : false;
            }
            ItemComponent = require(`./${componentItem.componentType}.js`).default;
        } catch (e) {
            console.log(e.toString())
        }
        let value = componentItem.value;
        let callBack = (val) => {
            this.onInformationChange({code: value, val})
        };
        let getValue = componentItem.getValue || value;
        let type =componentItem.type?componentItem.type:'createTask';
        let itemValue;
        if (getValue.indexOf(',') > -1) {
            try {
                itemValue = [eval(eval(getValue.split(','))[0]), eval(eval(getValue.split(','))[1])];
            } catch (e) {
                console.log(e.toString())
            }
        } else {
            itemValue = eval(getValue);
        }


       return (
            <ItemComponent
                key={index + "_" + _index}
                type={type}
                {...componentItem}
                itemValue={itemValue}
                show={show}
                callBack={callBack}
            />

        );
    };

    onInformationChange = ({code, val, setState = false}) => {
        if (code.indexOf(",") > -1) {
            let arr = code.split(",");
            arr.forEach((item, i) => {
                this.evalFun({code: item, val: val[i]});
            })
        } else {
            this.evalFun({code: code, val: val});
        }
        // 备注：只有动态字段需要使用${}包裹
        if (setState) {
            this.setState({});
        }
    };

    evalFun = ({code, val}) => {
        try {
            eval(`${code}=val`);
        } catch (e) {
            console.log(e.toString())
        }
    };

}

export default TaskMessage;